<nav class="mg-toolbar">
  <div class="mg-toolbar__menu">
    <div
      class="mg-toolbar__menu__popover"
      (click)="togglePopoverModules()"
      *ngIf="modules.length > 1 && showModules"
    >
      <mg-toggle-menu
        [activateAnimation]="false"
        class="toogle-popup"
      ></mg-toggle-menu>
      <mg-popover
        (elementSelected)="moduleSelected($event)"
        [elements]="modules"
        (closePopover)="ClosePopoverModules($event)"
        *ngIf="defaultVisible"
      ></mg-popover>
    </div>
    <mg-toggle-menu
      class="toogle-menu"
      [showMenu]="showMenu"
      (showMenuStatus)="showMenuStatus($event)"
    ></mg-toggle-menu>
    <span class="mg-toolbar__menu__module">
      {{ nameModule }}
    </span>
  </div>
  <div class="mg-toolbar__options">
    <div (click)="togglePopoverSettings()" class="mg-toolbar__options__name">
      <span class="mg-toolbar__options__name__user"
        >{{ greeting }} {{ user ? user.fullName : "" }}
      </span>
      <img
        *ngIf="user ? user.picture : false"
        [src]="user.picture"
        class="mg-toolbar__options__name__avatar"
        alt=""
      />
      <mg-icon
        *ngIf="!user?.picture"
        [size]="24"
        class="mg-toolbar__options__name__avatar"
        >account_circle</mg-icon
      >

      <mg-popover-list
        *ngIf="defaultVisibleSettings"
        [installEvent]="installEvent"
        (elementSelected)="settingsSelected($event)"
        (closePopover)="closePopoverSettings($event)"
      >
      </mg-popover-list>
    </div>

    <div
      class="mg-toolbar__options__translate"
      (click)="togglePopoverLanguage()"
    >
      <mg-icon [size]="24" class="mg-toolbar__options__translate__icon"
        >translate</mg-icon
      >
      <mg-translate
        (closeTraslate)="closeTraslate($event)"
        *ngIf="defaultVisibleLanguage"
      ></mg-translate>
    </div>

    <div
      class="mg-toolbar__options__notifications"
      (click)="togglePopoverNotifications()"
      *ngIf="viewNotifications"
    >
      <mg-icon [size]="24" class="mg-toolbar__options__notifications__icon"
        >notifications</mg-icon
      >
      <mg-notification
        [notifications]="notifications"
        *ngIf="defaultVisibleNotifications"
        (closePopover)="closePopoverNotifications($event)"
        (returnNotifations)="amountNotifications = $event"
      ></mg-notification>
    </div>
  </div>
</nav>
